import { render, staticRenderFns } from "./VHeader.vue?vue&type=template&id=430415fe&scoped=true"
import script from "./VHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./VHeader.vue?vue&type=script&setup=true&lang=js"
import style0 from "./VHeader.vue?vue&type=style&index=0&id=430415fe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "430415fe",
  null
  
)

export default component.exports